import React, { Component, Fragment } from "react";
import { setLoader, setDeeplink, setParams } from "../../../../redux/actions";
import { connect } from "react-redux";
import {
  Card,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import _axios from "../../../../libs/axios";
import { NotificationManager } from "../../../../components/common/react-notifications";
// import AppLocale from "../../../../config/lang";
import _moment from "../../../../libs/moment";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { objToQueryString } from "../../../../helpers/Utils";
import CustomDropdown from "../../../../components/utils/CustomDropdown";

class admConversations extends Component {
  constructor(props) {
    super(props);
    this.M = "admConversations."
    this.state = {
      conversations: [],
      conversation: null,
      selectedConversation: null,
      message: "",
      messages: [],
      filters: {
        filter: "",
        type: ""
      },
      openSidebar: false,
      dropdownOpen: false,
      selectedAction: "reply",
      types: [
        {value: "human", label: "Escalated"},
        {value: "open", label: "Open"},
        {value: "closed", label: "Closed"},
      ],
      progressBar: false,
      progressBarTwo: false,
      inactivityMinutes: 30,
      hasLocalMessage: false
    }
    this.psRef = React.createRef();
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.intervalCounter = 0;
    this.isFetchingMessages = false;
    this.fetchingMessagesConversationId = null;
    this.shouldMarkReadOnNextFetch = false;
    this.hasLoadedMessagesForSelection = false;
  }

  normalizeConversation = (conversation) => {
    if (!conversation) return conversation;
    return {
      ...conversation,
      isUnread: conversation.staffReadOn == null
    };
  }

  syncConversationReadState = (updatedConversation) => {
    if (!updatedConversation || !updatedConversation.ID) return;
    this.setState(prevState => ({
      conversations: prevState.conversations.map(c => (
        c.ID === updatedConversation.ID
          ? this.normalizeConversation({
            ...c,
            staffReadOn: updatedConversation.staffReadOn,
            staffReadBy: updatedConversation.staffReadBy
          })
          : c
      )),
      selectedConversation: prevState.selectedConversation?.ID === updatedConversation.ID
        ? this.normalizeConversation({
          ...prevState.selectedConversation,
          ...updatedConversation
        })
        : prevState.selectedConversation
    }));
  }

  markConversationReadLocally = (conversationId) => {
    if (!conversationId) return;
    const localReadOn = _moment().format();
    const localReadBy = this.props.userAdmin?.name || this.props.userAdmin?.email || null;
    this.setState(prevState => ({
      conversations: prevState.conversations.map(c => (
        c.ID === conversationId
          ? this.normalizeConversation({
            ...c,
            staffReadOn: c.staffReadOn || localReadOn,
            staffReadBy: c.staffReadBy || localReadBy
          })
          : c
      )),
      selectedConversation: prevState.selectedConversation?.ID === conversationId
        ? this.normalizeConversation({
          ...prevState.selectedConversation,
          staffReadOn: prevState.selectedConversation.staffReadOn || localReadOn,
          staffReadBy: prevState.selectedConversation.staffReadBy || localReadBy
        })
        : prevState.selectedConversation,
      conversation: prevState.conversation?.ID === conversationId
        ? {
          ...prevState.conversation,
          staffReadOn: prevState.conversation.staffReadOn || localReadOn,
          staffReadBy: prevState.conversation.staffReadBy || localReadBy
        }
        : prevState.conversation
    }));
  }

  stopPolling = () => {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  isWindowActive = () => {
    return document.visibilityState === "visible" && document.hasFocus();
  }

  startPolling = () => {
    this.stopPolling();
    if (this.state.selectedConversation) {
      this.interval = setInterval(() => {
        if (!this.isWindowActive()) return;
        this.fetchMessages();
        this.intervalCounter++;
        if (this.intervalCounter >= 3) {
          this.fetchConversations(false);
          this.intervalCounter = 0;
        }
      }, 10000);
      return;
    }

    this.interval = setInterval(() => {
      if (!this.isWindowActive()) return;
      this.fetchConversations(false);
    }, 10000);
  }

  formatDate(date) {
    // Convert from GMT-5 to local timezone
    const messageDate = _moment(date).utcOffset(-5, true).local();
    const now = _moment();
    const diffDays = now.diff(messageDate, 'days');
    
    if (diffDays === 0) {
      // Today
      return messageDate.format('hh:mm A');
    } else if (diffDays > 0 && diffDays <= 7) {
      // From yesterday and within last week
      const dayName = messageDate.format('dddd');
      return `${dayName.charAt(0).toUpperCase() + dayName.slice(1).toLowerCase()}, ${messageDate.format('hh:mm A')}`;
    } else {
      // Rest of dates
      return messageDate.format('DD/MM/YYYY hh:mm A');
    }
  }

  formatConversationListDate(date) {
    const conversationDate = _moment(date).utcOffset(-5, true).local();
    const now = _moment();

    if (conversationDate.isAfter(now.clone().subtract(24, "hours"))) {
      return conversationDate.format("HH:mm");
    }

    if (conversationDate.isSame(now.clone().subtract(1, "day"), "day")) {
      return "Yestarday";
    }

    if (conversationDate.isAfter(now.clone().subtract(7, "days"), "day")) {
      return conversationDate.format("dddd");
    }

    return conversationDate.format("DD/MM/YYYY");
  }

  scrollToBottom() {
    if (this.psRef.current) {
      const container = this.psRef.current;
      container._ps.update();
      container._ps.element.scrollTop = container._ps.element.scrollHeight;
    }
  }

  UNSAFE_componentWillMount() {
    this.fetchConversations()
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.messages.length !== this.state.messages.length) {
      // console.log("updated messages")
      this.scrollToBottom();
    }
    if (prevState.selectedConversation?.ID !== this.state.selectedConversation?.ID) {
      // console.log("change conversation")
      this.stopPolling();
      this.intervalCounter = 0;
      const shouldMarkAsRead = !!this.state.selectedConversation?.ID && (
        this.state.selectedConversation.isUnread ||
        this.state.selectedConversation.staffReadOn == null
      );
      this.shouldMarkReadOnNextFetch = shouldMarkAsRead;
      this.hasLoadedMessagesForSelection = false;
      this.setState({messages: [], openSidebar: false}, () => { // clear messages if I switch conversations
        if (this.state.selectedConversation) {
          // Set default inactivity minutes based on holdAiTill

          if(this.state.selectedConversation.holdAiTill){
            const defaultMinutes = this.getDefaultInactivityMinutes(this.state.selectedConversation.holdAiTill);
            this.setState({ inactivityMinutes: defaultMinutes });
          }
          
          this.fetchMessages();
          this.startPolling();
        } else {
          this.startPolling();
        }
      })
    }
  }

  componentWillUnmount() {
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    this.stopPolling();
    this.props.setParams(null)
  }

  handleVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      console.log("The user switched tabs or minimized the window.");
      this.stopPolling();
    } else if (document.visibilityState === "visible") {
      console.log("The user returned to the tab.");
      if (this.state.selectedConversation) {
        this.fetchMessages();
        this.intervalCounter = 0;
        this.startPolling();
      } else {
        // When no conversation is selected, only fetch conversations list
        this.fetchConversations(false);
        this.startPolling();
      }
    }
  }

  fetchConversations(loader = true) {
    if (loader) this.setState({ progressBar: true, data: []})
    const query = objToQueryString(this.state.filters)
    _axios
      .get(`admConversations/get?${query}`)
      .then(r => {
        if (r.status >= 0) {
          const normalizedResults = (r.data.Results || []).map(this.normalizeConversation);
          this.setState({conversations: normalizedResults})
          if (normalizedResults.length === 0) this.setState({selectedConversation: null})
          
          // Update selectedConversation with fresh data and recalculate inactivity minutes
          if (this.state.selectedConversation) {
            const updatedConversation = normalizedResults.find(c => c.ID === this.state.selectedConversation.ID);
            if (updatedConversation) {
              this.setState({selectedConversation: updatedConversation});
              const defaultMinutes = this.getDefaultInactivityMinutes(updatedConversation.holdAiTill);
              this.setState({ inactivityMinutes: defaultMinutes });
            }
          }
        } else NotificationManager.error(r.msg, 'Opps', 4000, null, null, 'outline')
        this.setState({ progressBar: false })
      })
  }

  fetchConversation(loader = true, conversationId = null, syncReadState = false) {
    if (loader) this.setState({ progressBarTwo: true, data: [], conversation: null})
    const ID = conversationId || this.state.selectedConversation?.ID
    if (!ID) return;
    _axios
      .get(`admConversations/get/${ID}`)
      .then(r => {
        if (r.status >= 0) {
          const normalizedConversation = this.normalizeConversation(r.data);
          this.setState({conversation: normalizedConversation});
          if (syncReadState) {
            this.syncConversationReadState(normalizedConversation);
          }
        } else NotificationManager.error(r.msg, 'Opps', 4000, null, null, 'outline')
        this.setState({ progressBarTwo: false })
      })
  }

  fetchMessages() {
    const { selectedConversation } = this.state
    if (!selectedConversation?.ID) return;

    // Prevent duplicate in-flight requests for the same conversation.
    if (this.isFetchingMessages && this.fetchingMessagesConversationId === selectedConversation.ID) return;

    const conversationId = selectedConversation.ID;
    const isInitialLoadForSelection = !this.hasLoadedMessagesForSelection;
    const shouldMarkRead = this.shouldMarkReadOnNextFetch;
    if (shouldMarkRead) this.shouldMarkReadOnNextFetch = false;
    this.isFetchingMessages = true;
    this.fetchingMessagesConversationId = conversationId;
    const url = shouldMarkRead
      ? `admConversations/${conversationId}/messages?read=true`
      : `admConversations/${conversationId}/messages`;

    _axios
      .get(url)
      .then(r => {
        if (this.state.selectedConversation?.ID !== conversationId) return;
        if (!this.isWindowActive()) return;
        if (r.status >= 0) {
          if (shouldMarkRead) this.markConversationReadLocally(conversationId);
          this.setState(prevState => {
            let messagesToMerge = prevState.messages;
            let hasLocalMessage = prevState.hasLocalMessage;

            // If we added a local message, remove the last message (the temp one)
            if (hasLocalMessage && prevState.messages.length > 0) {
              messagesToMerge = prevState.messages.slice(0, -1);
              hasLocalMessage = false;
            }

            const mergedArray = [...messagesToMerge, ...(r.data.Results || [])].reduce((accumulator, current) => {
              const exists = accumulator.find(item => item.ID === current.ID);
              if (!exists) {
                return [...accumulator, current];
              }
              return accumulator;
            }, []);

            const hasMoreMessagesAfterRefresh = mergedArray.length > messagesToMerge.length;
            const shouldSetUnreadLocally = !isInitialLoadForSelection && hasMoreMessagesAfterRefresh;

            return {
              messages: mergedArray,
              hasLocalMessage,
              conversations: shouldSetUnreadLocally
                ? prevState.conversations.map(c => (
                  c.ID === conversationId ? { ...c, isUnread: true } : c
                ))
                : prevState.conversations,
              selectedConversation: shouldSetUnreadLocally && prevState.selectedConversation?.ID === conversationId
                ? { ...prevState.selectedConversation, isUnread: true }
                : prevState.selectedConversation
            };
          });
          this.hasLoadedMessagesForSelection = true;
        } else NotificationManager.error(r.msg, 'Opps', 4000, null, null, 'outline')
      })
      .finally(() => {
        if (this.fetchingMessagesConversationId === conversationId) {
          this.isFetchingMessages = false;
          this.fetchingMessagesConversationId = null;
        }
      })
  }

  sendMessage(action = "send") {
      const { message, selectedConversation, messages } = this.state
      this.shouldMarkReadOnNextFetch = !!selectedConversation?.ID;
      
      // Create optimistic message object and push locally
      const timestamp = _moment().format('YYYYMMDDHHmm');
      const tempMessage = {
        ID: `A_${selectedConversation.ID}_${timestamp}`,
        text: action === "deescalate_now"?"[Conversation de-escalated, can be found in Open tab]": message
      };
      
      this.setState({
        message: "",
        messages: [...messages, tempMessage],
        hasLocalMessage: true
      });
      
      const body = action === "deescalate_now"? null:{
        type: "text",
        msg: message,
      };
      
      // Build the URL with escalated parameter for de-escalation actions
      let url = `admConversations/${selectedConversation.ID}/messages`;
      if (action === "deescalate_with_reply" || action === "deescalate_now") {
        url += "?escalate=-1";
      }
      
    _axios
      .post(url, body)
      .then(r => {
        if (r.status >= 0) {
          // Set conversation.closed to false and holdAiTill to 30 min in the future
          const newHoldAiTill = _moment().add(30, 'minutes').format();
          this.setState({
            selectedConversation: {
              ...selectedConversation,
              closed: false,
              holdAiTill: newHoldAiTill
            },
            inactivityMinutes: 30
          });

          // set selectedaction to reply
          this.setState({selectedAction: "reply"});
          
          if (action === "deescalate" || action === "deescalate_with_message") {
            this.fetchConversations()
          }
        } else NotificationManager.error(r.msg, 'Opps', 4000, null, null, 'outline')
      })
  }

  handleSidebar = () => {
    this.setState({openSidebar: !this.state.openSidebar }, () => {
      if (this.state.openSidebar) this.fetchConversation()
    })
  }

  handleChangeSearch = (e) => {
    this.setState({filters: {...this.state.filters, ...{filter: e.target.value}}})
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.fetchConversations()
    }
  }

  onChangeType = (value) => {
    this.setState({filters: {...this.state.filters, ...{type: value}}, selectedConversation: null, messages: [], conversations: []}, () => {
      this.fetchConversations()
    })
  }

  changeToHuman = (selectedConversation) => {
    const newHoldAiTill = _moment().add(this.state.inactivityMinutes, 'minutes').format();
    this.setState({
      selectedConversation: {
        ...selectedConversation,
        holdAiTill: newHoldAiTill
      }
    });
  }

  handleInputMessage = (e) => {
    this.setState({message: e.target.value})
  }

  handleKeyPressInMessage = (event) => {
    if (event.key === 'Enter') {
      this.sendMessage()
    }
  }

  openWhatsApp = () => {
    const { conversation } = this.state
    if (conversation && conversation.chatUser) {
      const phoneNumber = conversation.chatUser.replace(/\D/g, '') // Remove non-digits
      
      const userName = this.props.userAdmin.name
      const companyName = this.props.userAdmin.companyName

      const contextMessage = `Hi ${conversation.chatUserName}! I am *${userName}* from *${companyName}*. Our digital assistant transferred us this conversation with you:`+
      `\n\n> ${conversation.summary || 'your inquiry'}\n\nLet me assist you on this now.`;
      
      const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(contextMessage)}`
      
      // Open in new window
      window.open(whatsappUrl, '_blank', 'noopener,noreferrer')
    }
  }

  formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return '';
    
    // Remove any non-digit characters
    const digits = phoneNumber.replace(/\D/g, '');
    
    // UAE number format: +971 5X XXX XXXX
    if (digits.startsWith('971') && digits.length === 12) {
      return `+971 ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`;
    }
    
    // Basic formatting based on length
    if (digits.length === 10) {
      // Format as (XXX) XXX-XXXX
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    } else if (digits.length === 11 && digits.startsWith('1')) {
      // US number with country code: 1-XXX-XXX-XXXX
      return `+1 ${digits.slice(1, 4)}-${digits.slice(4, 7)}-${digits.slice(7)}`;
    } else if (digits.length > 10) {
      // International number: +XX XXX XXX XXXX
      const countryCode = digits.slice(0, digits.length - 10);
      const localNumber = digits.slice(digits.length - 10);
      return `+${countryCode} ${localNumber.slice(0, 3)} ${localNumber.slice(3, 6)} ${localNumber.slice(6)}`;
    } else if (digits.length === 9) {
      // 9-digit number: XXX XXX XXX
      return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
    } else {
      // For other lengths, just add + prefix
      return `+${digits}`;
    }
  }

  getTimeRemaining(holdAiTill) {
    if (!holdAiTill) return null;
    
    const now = _moment();
    const holdDate = _moment(holdAiTill).utcOffset(-5, true).local();
    const diffMinutes = holdDate.diff(now, 'minutes');
    
    const absMinutes = Math.abs(diffMinutes);
    const sign = diffMinutes < 0 ? '-' : '';
         
    if (absMinutes < 60) {
      return `${sign}${absMinutes}m`;
    } else {
      const hours = Math.floor(absMinutes / 60);
      return `${sign}${hours}hr`;
    }
  }

  getTimerColor(holdAiTill) {
    if (!holdAiTill) return '';
    
    const now = _moment();
    const holdDate = _moment(holdAiTill).utcOffset(-5, true).local();
    const diffMinutes = holdDate.diff(now, 'minutes');
    
    if (diffMinutes < 5) return '#f5c2c7'; // light red
    if (diffMinutes < 15) return '#ffb380'; // light orange
    return '#a8d5b5'; // light green
  }

  getDefaultInactivityMinutes(holdAiTill) {
    
    const now = _moment();
    const holdDate = _moment(holdAiTill).utcOffset(-5, true).local();
    const diffMinutes = holdDate.diff(now, 'minutes');
    
    return Math.max(5, Math.round(diffMinutes)); // Minimum 5 minutes
  }

  adjustInactivityMinutes(delta) {
    this.setState(prevState => ({
      inactivityMinutes: Math.max(5, prevState.inactivityMinutes + delta)
    }));
  }

  isImageFile = (url) => {
    if (!url) return false;
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
    const extension = url.split('.').pop().toLowerCase().split('?')[0];
    return imageExtensions.includes(extension);
  }

  renderMedia = (media) => {
    if (!media) return null;

    if (this.isImageFile(media)) {
      return (
        <div className="mt-2">
          <img 
            src={media} 
            alt="attachment" 
            style={{
              maxWidth: '100%',
              maxHeight: '300px',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
            onClick={() => window.open(media, '_blank', 'noopener,noreferrer')}
          />
        </div>
      );
    } else {
      return (
        <div className="mt-2">
          <a 
            href={media} 
            target="_blank" 
            rel="noopener noreferrer"
            className="d-inline-flex align-items-center text-primary"
            style={{textDecoration: 'none'}}
          >
            <i className="simple-icon-paper-clip mr-2" style={{fontSize: '1.2rem'}}></i>
            <span>View attachment</span>
          </a>
        </div>
      );
    }
  }

  createMessage = (message, index) => {
    const dateStr = message.ID.split("_")[2]
    const hour = this.formatDate(_moment(dateStr, "YYYYMMDDHHmm"))
    if (message.ID.startsWith("U")) {
      return (
        <div className="w-100 d-flex justify-content-end my-2 fadeIn" key={index}>
          <div className="w-75 d-inline-block card mx-3 theme-color-1-20">
            <div className="position-absolute  pt-1 pr-2 r-0">
              <span className="text-extra-small text-muted">{hour}</span>
            </div>
            <div className="card-body">
              <div className="d-flex flex-row pb-1">
              </div>
              <div className="chat-text-left" dir="auto" style={{textAlign: 'start'}}>
                <p className="mb-0 text-semi-muted" style={{textAlign: 'start'}}>{message.text}</p>
                {this.renderMedia(message.media)}
              </div>
            </div>
          </div>
        </div>
      )
    } else if (message.ID.startsWith("A")) {
      return (
        <div className="w-100 d-flex justify-content-start my-2 fadeIn" key={index}>
          <div className="w-75 d-inline-block card mx-3">
            <div className="position-absolute  pt-1 pr-2 r-0">
              <span className="text-extra-small text-muted">{hour}</span>
            </div>
            <div className="card-body">
              <div className="d-flex flex-row pb-1">
              </div>
              <div className="chat-text-left" dir="auto" style={{textAlign: 'start'}}>
                <p className="mb-0 text-semi-muted" style={{textAlign: 'start'}}>{message.text}</p>
                {this.renderMedia(message.media)}
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  render() {
    // const { locale, params } = this.props
    // const L = AppLocale[locale].messages
    const { conversation, conversations, selectedConversation, message, messages, openSidebar, types } = this.state
    return (
      <Fragment>
        <Card className="rounded-0 shadow-none ">
          <div className="ai-chatbot">
            <section className="xsidebar">
              <div className="xtoolbar"><h4 className="m-0">Conversations</h4></div>
              <div className="filters">
                <div className="search-lg min-width-max-content">
                  <input 
                    type="text"
                    placeholder="Search" 
                    value={this.state.filters.filter}
                    onChange={this.handleChangeSearch}
                    onKeyUp={this.handleKeyPress}
                  />
                  <i
                    className={this.state.filters.filter ? "simple-icon-close" : "simple-icon-magnifier"}
                    onClick={() => this.setState({filters: {...this.state.filters, filter: ""}}, () => {
                      this.fetchConversations()
                    })}
                  ></i>
                </div>
                <div className="wrap-tags">
                  {types.map((type, index) => {
                    return (
                      <Button
                        key={index}
                        className={`tag truncate ${this.state.filters?.type === type.value ? "active" : ""}`}
                        outline
                        color="primary"
                        onClick={() => this.onChangeType(type.value)}
                      >
                        {type.label}
                      </Button>
                    )
                  })}
                </div>
              </div>
              <div className="contacts">
                <PerfectScrollbar
                  className="ai-chatbot-perfect-scrollbar"
                  options={{ suppressScrollX: true, wheelPropagation: false }}
                >
                  {this.state.progressBar && <div className="progress"><div className="indeterminate"></div></div>}
                  {!this.state.progressBar && conversations.length === 0 ? (
                    <div className="text-center text-muted text-small py-4">
                      No {this.state.filters.type || ''} conversations.
                    </div>
                  ) : (
                    conversations.map((c, index) => {
                      const timeRemaining = this.getTimeRemaining(c.holdAiTill);
                      const timerColor = this.getTimerColor(c.holdAiTill);
                      
                      // Calculate if remaining time is 0 or less
                      const now = _moment();
                      const holdDate = c.holdAiTill ? _moment(c.holdAiTill).utcOffset(-5, true).local() : null;
                      const diffMinutes = holdDate ? holdDate.diff(now, 'minutes') : null;
                      
                      // Show timer only if: there is timeRemaining AND (conversation is escalated OR remaining time is positive)
                      const showTimer = timeRemaining && (c.escalated || (diffMinutes !== null && diffMinutes > 0));
                      
                      return (
                        <div 
                          className={`d-flex flex-row p-2 m-2 pointer ${selectedConversation?.ID === c.ID ? "active" : ""}`}
                          key={index}
                          onClick={ () => { this.setState({selectedConversation: this.normalizeConversation(c)}) } }
                        >
                          <div className="overflow-auto d-flex align-items-center w-100">
                            <div>
                              {showTimer ? (
                                <div 
                                  className="d-flex align-items-center justify-content-center mr-3"
                                  style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    backgroundColor: timerColor,
                                    color: 'white',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                  }}
                                >
                                  {timeRemaining}
                                </div>
                              ) : (
                                <img 
                                  alt="" 
                                  src={require("../../../../assets/img/user.png")}
                                  onError={(e) => { e.target.onerror = null; e.target.src = require("../../../../assets/img/user.png") }} 
                                  className="img-thumbnail border-0 rounded-circle mr-3 list-thumbnail align-self-center xsmall"
                                />
                              )}
                            </div>
                            <div className="overflow-auto w-100">
                              <div className="overflow-auto d-flex align-items-center justify-content-between">
                                <h5 className="mb-0 truncate">{c.user}</h5>
                                <div className="d-flex flex-column align-items-end ml-2" style={{ minWidth: '96px' }}>
                                  <p className="mb-0 text-muted text-small text-right w-100">{this.formatConversationListDate(c.updatedAt)}</p>
                                  {c.isUnread && (
                                    <span
                                      style={{
                                        width: '8px',
                                        height: '8px',
                                        borderRadius: '50%',
                                        backgroundColor: 'var(--theme-color-1)',
                                        marginTop: '4px'
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                              <p className="truncate mb-1 text-muted text-small">{c.context}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </PerfectScrollbar>
              </div>
            </section>
            <section className="xchat">
              {selectedConversation
                ? 
                <>
                  <div className="chat-body">
                    <div className="xtoolbar justify-content-between">
                      
                      <div className="overflow-auto d-flex align-items-center pointer" onClick={() => this.handleSidebar() }>
                        <div>
                          <img alt=""
                            src={require("../../../../assets/img/user.png")} 
                            onError={(e) => { e.target.onerror = null; e.target.src = require("../../../../assets/img/user.png") }} 
                            className="img-thumbnail border-0 rounded-circle mr-3 list-thumbnail align-self-center xsmall"
                          />
                        </div>
                        <div className="overflow-auto">
                          <h4 className="mb-0 truncate">{selectedConversation.user}</h4>
                          <p className="mb-1 truncate text-muted text-small">{this.formatDate(selectedConversation.updatedAt)}</p>
                        </div>
                      </div>
                    
                      <div>
                        <CustomDropdown
                          icon="simple-icon-options-vertical"
                          direction="left"
                          key={selectedConversation.ID}
                          items={[
                            {name: "Conversation details", onClick: () => this.handleSidebar() },
                            {name: `Contact ${selectedConversation.user} directly on WhatsApp`, onClick: () => this.handleSidebar() }
                          ]}
                        />
                      </div>
                    </div>
                    <div className="chat-content">
                      <PerfectScrollbar 
                        className="ai-chatbot-perfect-scrollbar" 
                        options={{ suppressScrollX: true, wheelPropagation: false }}
                        ref={this.psRef}
                      >
                        {messages.map((msg, index) => {
                          return this.createMessage(msg, index)
                        }) }
                        
                        {/* Agent takeover button or escalated banner */}
                        {selectedConversation && messages.length > 0 && (
                          selectedConversation.escalated ? (
                            <div className="w-100 d-flex justify-content-center my-3 fadeIn">
                              <div className="d-flex align-items-center border rounded px-3 py-2" style={{ backgroundColor: '#fff3cd', borderColor: '#ffc107' }}>
                                <span className="mx-3 text-dark" style={{ fontSize: '0.9rem' }}>
                                  Agent will not take over until you de-escalate
                                </span>
                              </div>
                            </div>
                          ) : (
                            selectedConversation.holdAiTill && _moment().isBefore(_moment(selectedConversation.holdAiTill).utcOffset(-5, true).local()) && (
                              <div className="w-100 d-flex justify-content-center my-3 fadeIn">
                                <div className="d-flex align-items-center border rounded px-3 py-2" style={{ backgroundColor: 'white' }}>
                                  <Button 
                                    color="primary" 
                                    size="sm" 
                                    className="px-2 py-1"
                                    onClick={() => this.adjustInactivityMinutes(-5)}
                                    style={{ minWidth: '30px' }}
                                  >
                                    <strong>-</strong>
                                  </Button>
                                  <span className="mx-3 text-muted" style={{ fontSize: '0.8rem' }}>
                                    Agent will takeover after <strong>{this.state.inactivityMinutes}</strong> min of inactivity
                                  </span>
                                  <Button 
                                    color="primary" 
                                    size="sm" 
                                    className="px-2 py-1"
                                    onClick={() => this.adjustInactivityMinutes(5)}
                                    style={{ minWidth: '30px' }}
                                  >
                                    <strong>+</strong>
                                  </Button>
                                </div>
                              </div>
                            )
                          )
                        )}
                      </PerfectScrollbar>
                    </div>
                    <div className="chat-input-wrapper border-top">

                      {this.state.filters.type === "open" && (!selectedConversation.holdAiTill || _moment().isAfter(_moment(selectedConversation.holdAiTill).utcOffset(-5, true).local()))
                        ?
                          <div className="w-100 d-flex align-items-center justify-content-between">
                            <p className="p-0 m-0">Conversation is being handled by Looc.ai</p>
                            <Button 
                              color="success" 
                              size="xs" 
                              onClick={() => this.changeToHuman(selectedConversation)}
                            >
                              Join or Takeover conversation
                            </Button>
                          </div>
                        :
                          <div className="w-100 d-flex align-items-center">
                            <div className="input-group" style={{ border: '1px solid #ced4da', borderRadius: '20px', overflow: 'visible', position: 'relative' }}>
                              <input
                                type="text"
                                placeholder="Type message"
                                className="form-control"
                                style={{ border: 'none' }}
                                value={message}
                                onChange={this.handleInputMessage}
                                onKeyUp={this.handleKeyPressInMessage}
                              />
                              <div className="input-group-append">
                                {selectedConversation?.escalated && (
                                  <Dropdown isOpen={this.state.dropdownOpen} toggle={() => this.setState({dropdownOpen: !this.state.dropdownOpen})}>
                                    <DropdownToggle 
                                      caret
                                      outline
                                      color="secondary"
                                      className="dropdown-toggle"
                                      style={{ border: 'none', backgroundColor: 'transparent', color: '#000', display: 'flex', alignItems: 'center' }}
                                    >
                                    <i className={
                                      this.state.selectedAction === "reply" ? "simple-icon-user" :
                                      this.state.selectedAction === "deescalate_with_reply" ? "simple-icon-arrow-down" :
                                      "simple-icon-logout"
                                    }></i>
                                  </DropdownToggle>
                                  <DropdownMenu right>
                                  <DropdownItem 
                                      onClick={() => this.setState({selectedAction: "reply", dropdownOpen: false})}
                                      active={this.state.selectedAction === "reply"}
                                    >
                                      <i className="simple-icon-user mr-2"></i>
                                      Reply to the customer
                                    </DropdownItem>
                                    <DropdownItem 
                                      onClick={() => this.setState({selectedAction: "deescalate_with_reply", message: "Let me know if I can help with anything else", dropdownOpen: false})}
                                      active={this.state.selectedAction === "deescalate_with_reply"}
                                    >
                                      <i className="simple-icon-arrow-down mr-2"></i>
                                      De-escalate with a reply
                                    </DropdownItem>
                                    <DropdownItem 
                                      onClick={() => {
                                        this.setState({selectedAction: "deescalate_now", dropdownOpen: false});
                                        this.sendMessage("deescalate_now");
                                      }}
                                      active={this.state.selectedAction === "deescalate_now"}
                                    >
                                      <i className="simple-icon-logout mr-2"></i>
                                      De-escalate silently
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                                )}
                              </div>
                            </div>
                            <Button 
                              type="button" 
                              className="btn-send ml-2" 
                              disabled={!message && this.state.selectedAction !== "deescalate_now"} 
                              onClick={() => this.sendMessage(this.state.selectedAction)}
                            >
                              <i className="icomoon-message"></i>
                            </Button>
                          </div>
                      }
                    </div>
                  </div>
                  <div className={ `chat-sidebar ${openSidebar ? "chat-sidebar-active" : ""}`}>
                    <div className="xtoolbar">
                      <button className="btn btn-empty btn-close mr-3" onClick={() => this.handleSidebar() }>
                        <i className="icomoon-close icon-action"></i>
                      </button>
                      <h4 className="m-0">Contact Info</h4>
                    </div>
                    <div className="chat-sidebar-content">
                      <PerfectScrollbar 
                        className="ai-chatbot-perfect-scrollbar" 
                        options={{ suppressScrollX: true, wheelPropagation: false }}
                      >
                        {this.state.progressBarTwo && <div className="progress"><div className="indeterminate"></div></div>}
                        <div className="p-3">
                        {conversation && 
                          <>
                            <div className="d-flex align-items-start">
                              <img 
                                alt="" 
                                src={require("../../../../assets/img/user.png")}
                                onError={(e) => { e.target.onerror = null; e.target.src = require("../../../../assets/img/user.png") }} 
                                className="img-thumbnail border-0 rounded-circle list-thumbnail xsmall mr-2"
                              />
                              <div className="flex-grow-1">
                                <h3 
                                  className="pointer text-primary mb-1"
                                  onClick={this.openWhatsApp}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {conversation.chatUserName}
                                </h3>
                                <p className="mb-0 text-muted" onClick={this.openWhatsApp} style={{ cursor: 'pointer' }}>{this.formatPhoneNumber(conversation.chatUser)} </p>
                                <Button 
                                  size="xs" 
                                  color="neutral" 
                                  className="mt-2"
                                  onClick={this.openWhatsApp}
                                >
                                  <i className="icomoon-whatsapp mr-1"></i>
                                  Contact directly
                                </Button>
                              </div>
                            </div>
                            <hr></hr>
                            <div>
                              <div className="mb-2">
                                <div className="font-weight-bold">Conversation started</div>
                                <div>{this.formatDate(conversation.createdAt)}</div>
                              </div>
                              <div className="mb-2">
                                <div className="font-weight-bold">Conversation updated</div>
                                <div>{this.formatDate(conversation.updatedAt)}</div>
                              </div>
                              <div className="mb-2">
                                <div className="font-weight-bold">Staff read status</div>
                                {conversation.staffReadOn ? (
                                  <div>
                                    Read by {conversation.staffReadBy || 'Unknown'} on {this.formatDate(conversation.staffReadOn)}
                                  </div>
                                ) : (
                                  <div>Unread</div>
                                )}
                              </div>
                              <div className="mb-2">
                                <div className="font-weight-bold">Sentiment</div>
                                <div>{conversation.sentimentName}</div>
                              </div>
                              <div className="mb-2">
                                <div className="font-weight-bold">Satisfaction</div>
                                <div>{conversation.satisfactionName}</div>
                              </div>
                              <div className="mb-2">
                                <div className="font-weight-bold">Summary</div>
                                <div>{conversation.summary}</div>
                              </div>
                              <div className="mb-2">
                                <div className="font-weight-bold">Flow name</div>
                                <div>{conversation.flowName}</div>
                              </div>
                              {conversation.pastConversations && 
                                <div className="mb-2">
                                  <div className="font-weight-bold">Related conversations</div>
                                  <div>
                                    {conversation.pastConversations.map((pc, index) => (
                                      <div
                                        key={index} 
                                        className="pointer text-primary mb-2"
                                        onClick={() => this.setState({selectedConversation: {...selectedConversation, ...{ID: pc.ID}}})}
                                      >
                                        {this.formatDate(pc.date)}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              }
                            </div>
                          </>
                        }
                        </div>
                      </PerfectScrollbar>
                    </div>
                  </div>
                </>
                :
                <div className="w-100 d-flex align-items-center justify-content-center">
                  <div className="text-center">
                    <h1 className="mb-0 pb-0"><i className="iconsminds-speach-bubbles text-semi-muted" style={{fontSize: "5rem"}}></i></h1>
                    <h2 className="text-semi-muted">Select a conversation</h2>
                  </div>
                </div>
              }
            </section>
          </div>
        </Card>
      </Fragment>
    )
  }
}

const mapStateToProps = ({ settings, menu, utils, authUser }) => {
  const { menuItems } = menu
  const { locale } = settings
  const { deepLink, params } = utils
  const { userAdmin } = authUser
  return { locale, menuItems, deepLink, params, userAdmin }
}

export default connect(mapStateToProps, { setLoader, setDeeplink, setParams })(admConversations);